import { SVGProps } from 'react';

export const FiltersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M8.00004 2C9.8365 2 11.6368 2.1547 13.3887 2.45178C13.7439 2.51202 14 2.82237 14 3.18268V3.87868C14 4.2765 13.842 4.65803 13.5607 4.93934L9.93934 8.56066C9.65804 8.84196 9.5 9.2235 9.5 9.62132V11.5729C9.5 12.1411 9.179 12.6605 8.67082 12.9146L6.5 14V9.62132C6.5 9.2235 6.34196 8.84196 6.06066 8.56066L2.43934 4.93934C2.15804 4.65804 2 4.2765 2 3.87868V3.1827C2 2.82238 2.25605 2.51203 2.61129 2.45179C4.3632 2.1547 6.16355 2 8.00004 2Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
